import { render, staticRenderFns } from "./Astronomy.vue?vue&type=template&id=2582dfac&scoped=true&"
import script from "./Astronomy.vue?vue&type=script&lang=js&"
export * from "./Astronomy.vue?vue&type=script&lang=js&"
import style0 from "./Astronomy.vue?vue&type=style&index=0&id=2582dfac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582dfac",
  null
  
)

export default component.exports